import { LinearProgress, Typography } from '@material-ui/core';
import Alert from '@mui/material/Alert';
import React from 'react';
import Helmet from 'react-helmet';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useNotificationSettingsPageQuery } from 'generated/graphql';
import { selectUser } from 'entities/user/selectors';
import { Privileges } from 'utils/privileges';
import { PageBannerContainer } from 'components/PageBannerContainer/PageBannerContainer';
import CampaignsPageBanner from 'assets/pageBanners/campaigns.avif';

import { NotificationSettingsForm } from './NotificationSettingsForm';

const NotificationSettingsPage = (): JSX.Element => {
  const history = useHistory();

  const user = useSelector(selectUser);

  const { data, loading, error } = useNotificationSettingsPageQuery();

  if (user && !user?.hasPrivilege(Privileges.NOTIFCATIONS_ORGANIZATION_MANAGE)) {
    history.replace('/');
  }

  return (
    <>
      <Helmet title="Notification Settings" />
      <div>
        <PageBannerContainer color="#E9EAFF" backgroundImage={CampaignsPageBanner}>
          <h1>Notifications</h1>
        </PageBannerContainer>

        <h2>Emails</h2>
        <Typography>
          For the ideal Deed experience, it is recommended you enable all emails. We understand
          certain circumstances may require you to temporarily disable emails company wide, which
          you can do by disabling the email or email category below. In some cases, we are required
          to send emails for regulatory purposes or essential onboarding steps. Those emails are
          greyed out and may not be disabled.
        </Typography>
        {data && <NotificationSettingsForm data={data} />}
        <div style={{ marginTop: 12 }}>
          {error && (
            <Alert severity="error">
              We ran into an error!
              <br />
              <br />
              {error?.message}
            </Alert>
          )}
          {loading ? <LinearProgress /> : <div style={{ height: 4 }} />}
        </div>
      </div>
    </>
  );
};

export default NotificationSettingsPage;
